import parseServerTimingHeader from '@wix/communities-blog-universal/dist/src/utils/parse-server-timing-header';

export const getPageLoadMetrics = () => {
  if (typeof performance === 'undefined' || !performance.getEntriesByType) {
    return;
  }
  const navigation = performance.getEntriesByType('navigation');
  const metrics = navigation && navigation[0];

  if (!metrics.domComplete) {
    return undefined;
  }

  const normalizeTime = time => Math.trunc(time * 1000);

  return {
    timeToFirstByte: normalizeTime(metrics.responseStart - metrics.requestStart),
    contentTransfer: normalizeTime(metrics.responseEnd - metrics.responseStart),
    domInteractive: normalizeTime(metrics.domInteractive - metrics.responseEnd),
    domContentLoad: normalizeTime(metrics.domComplete - metrics.domInteractive),
    transferSize: metrics.transferSize,
  };
};

const performanceTracker = {
  trackStart: key => {
    const marker = `${new Date().toISOString().slice(11)} ${key}`;
    window.__CLIENT_METRICS__[marker] = performance.now();
    return marker;
  },
  trackEnd: (marker, subValues) =>
    (window.__CLIENT_METRICS__[marker] = { value: performance.now() - window.__CLIENT_METRICS__[marker], subValues }),
  parseHeader: parseServerTimingHeader,
};

export default performanceTracker;
